import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import LoginPage from './pages/LoginPage';
import Shell from './components/Shell';
import VaultPage from './pages/VaultPage';
import GroupsPage from './pages/GroupsPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import LogsPage from './pages/LogsPage';

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}

function AdminRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/" element={<PrivateRoute><Shell /></PrivateRoute>}>
        <Route index element={<Navigate to="/vault" replace />} />
        <Route path="vault"     element={<VaultPage />} />
        <Route path="groups"    element={<GroupsPage />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="users"     element={<AdminRoute><UsersPage /></AdminRoute>} />
        <Route path="logs"      element={<AdminRoute><LogsPage /></AdminRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <AppRoutes />
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
